import { render, staticRenderFns } from "./VDesignTaskUsersSelect.vue?vue&type=template&id=7a552c31&"
import script from "./VDesignTaskUsersSelect.vue?vue&type=script&lang=ts&"
export * from "./VDesignTaskUsersSelect.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignTaskUsersSelect.vue?vue&type=style&index=0&id=7a552c31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports